import * as api from '../api/billing-vouchers';
import q from '../query';
export const billingVouchersKey = (caseId) => `billing-vouchers-${caseId}`;
export const useBillingVouchers = (caseId) => q.query(billingVouchersKey(caseId), () => api.getByCaseId(caseId), []);
//# sourceMappingURL=index.js.map